import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'patient/:token',
    loadComponent: () =>
      import('./modules/upload-patient-image/upload-patient-image-page').then(
        (m) => m.UploadPatientImagePage,
      ),
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./modules/landing/landing-page').then((m) => m.LandingPage),
  },
  {
    path: '**',
    loadComponent: () => import('./modules/landing/landing-page').then((m) => m.LandingPage),
  },
];
